export enum Tenancy {
  SFA = 'SFA',
  CPT = 'CPT'
}
